import React, { useState } from "react";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";
import DescriptionIcon from "@mui/icons-material/Description";
import FormattedDate from "../../../components/TimeStamp";
import SafeHtml from "@egovernments/digit-ui-module-common/src/sharedComponents/SafeHtml";

const DrawingsDetailsTable = ({ detailData }) => {
  const detailsArray = Array.isArray(detailData) ? detailData : [detailData];
  const [popupData, setPopupData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const openPopup = (item) => {
    setPopupData(item);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setPopupData(null);
  };

  const printPopup = () => {
    const popupContent = document.getElementById("drawings-popup-print");
    if (!popupContent) return;

    const printWindow = window.open("", "_blank", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Drawings</title>
          <style>
            body { font-size: 12px; font-family: Arial; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ccc; padding: 6px; }
            th { background-color: #f0f0f0; }
          </style>
        </head>
        <body>
          ${popupContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  const renderFileIcon = (url, label) =>
    url ? (
      <a href={url} target="_blank" rel="noopener noreferrer" title={label}>
        <IconButton size="small">
          <DescriptionIcon fontSize="small" />
        </IconButton>
      </a>
    ) : (
      "-"
    );

  return (
    <div>
      <h3 style={{ fontWeight: "bold", marginBottom: "10px" }}>Drawings Details Summary</h3>
      <div style={{ overflowX: "auto", maxHeight: "300px", overflowY: "scroll" }}>
        <table
          border="1"
          cellPadding="8"
          width="100%"
          style={{
            borderCollapse: "collapse",
            minWidth: "800px",
            fontSize: "11px",
            position: "relative",
          }}
        >
          <thead style={{ backgroundColor: "rgba(52, 73, 94, 0.94)", position: "sticky", top: 0, zIndex: 2 }}>
            <tr style={{ fontSize: "14px", backgroundColor: "rgba(52, 73, 94, 0.94)", color: "#fff" }}>
              <th>User</th>
              <th>Designation</th>
              <th>Recommendation</th>
              <th>Observation</th>
              <th>Date & Time</th>
              <th>Details</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {detailsArray.map((item, index) => {
              const user = item?.userDetails || {};
              const createdTime = item?.auditDetails?.createdTime || null;
              const recommendation = item?.drawingsDetails?.dataRecommendation;
              const observation = item?.drawingsDetails?.developerObjection;
              const remarks = item?.drawingsDetails?.developerRemarks;

              return (
                <tr key={index}>
                  <td>{user?.employeeName || user?.name || "-"}</td>
                  <td>{user?.designation || "-"}</td>
                  <td>{recommendation || "-"}</td>
                  <td>
                    {observation?.filter(Boolean).map((objection, index) => (
                      <div key={index}>
                        {index + 1}. {objection}
                      </div>
                    )) || "-"}
                  </td>
                  <td>
                    <FormattedDate timestamp={createdTime} />
                  </td>
                  <td>
                    <IconButton onClick={() => openPopup(item)} size="small">
                      <VisibilityIcon fontSize="small" />
                    </IconButton>
                  </td>
                  <SafeHtml html={remarks || "-"} tag="td" />
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Popup */}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            top: "15%",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "20px",
            zIndex: 1000,
            maxHeight: "80vh",
            overflowY: "auto",
            width: "75%",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            fontSize: "12px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3>Drawing Info</h3>
            <div>
              <IconButton onClick={printPopup} title="Print">
                <PrintIcon />
              </IconButton>
              <IconButton onClick={closePopup} title="Close">
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          <div id="drawings-popup-print">
            {popupData?.userDetails && (
              <div style={{ marginBottom: "10px" }}>
                <strong>User:</strong> {popupData.userDetails?.employeeName || popupData.userDetails?.name || "-"} | <strong>Designation:</strong>{" "}
                {popupData.userDetails?.designation || "-"} | <strong>Created:</strong>{" "}
                <FormattedDate timestamp={popupData.auditDetails?.createdTime} />
              </div>
            )}

            <table border="1" cellPadding="6" width="100%" style={{ borderCollapse: "collapse", fontSize: "12px" }}>
              <thead style={{ backgroundColor: "#e2e8f0" }}>
                <tr>
                  <th>Status</th>
                  {/* <th>Drawing Name</th> */}

                  <th>Drawing PDF</th>
                  <th>DXF</th>
                  <th>Updated DXF</th>
                  <th>Plan Report</th>
                  <th>Submitted On</th>
                </tr>
              </thead>
              <tbody>
                {(popupData?.drawingsDetails?.drawingsDetails || []).map((drawing, i) => (
                  <tr key={i}>
                    <td>{drawing?.status || "-"}</td>
                    {/* <td>{drawing?.drawingName || "-"}</td> */}

                    <td>{renderFileIcon(drawing?.drawingPdf, "Drawing PDF")}</td>
                    <td>{renderFileIcon(drawing?.dxfFile, "DXF File")}</td>
                    <td>{renderFileIcon(drawing?.updatedDxfFile, "Updated DXF")}</td>
                    <td>{renderFileIcon(drawing?.planReport, "Plan Report")}</td>
                    <td>
                      <FormattedDate timestamp={drawing?.submittedOn} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default DrawingsDetailsTable;
